const staticFile = {
  uploadPhoto: "/static/images/uploadPhoto.png",
  imageUndefined: "/static/images/undefinedImg.png",
  cardLogo: "/static/images/card-photo.png",
};

export default staticFile;
